import { createAction, props } from '@ngrx/store';

export const updateNotSavedFranchiseMSP = createAction(
  'Update Not Saved Franchise MSP',
  props<{ partPricingId: string; franchiseMSP: number; isValid: boolean }>()
);

export const removeAllNotSavedFranchiseMSP = createAction('Remove All Not Saved Franchise MSP');
